__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@ahamove/account";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ahamove/design-tokens", "0.2.0", () => (__webpack_require__.e(223).then(() => (() => (__webpack_require__(60223))))));
			register("@fingerprintjs/fingerprintjs-pro-react", "2.2.0", () => (__webpack_require__.e(1349).then(() => (() => (__webpack_require__(91349))))));
			register("@hookform/resolvers", "2.9.7", () => (Promise.all([__webpack_require__.e(4918), __webpack_require__.e(6604)]).then(() => (() => (__webpack_require__(66604))))));
			register("@sentry/react", "7.12.1", () => (Promise.all([__webpack_require__.e(9364), __webpack_require__.e(8861), __webpack_require__.e(8511)]).then(() => (() => (__webpack_require__(28861))))));
			register("@sentry/tracing", "7.12.1", () => (Promise.all([__webpack_require__.e(9364), __webpack_require__.e(225), __webpack_require__.e(3519)]).then(() => (() => (__webpack_require__(225))))));
			register("@tanstack/react-query-devtools", "4.2.1", () => (__webpack_require__.e(9970).then(() => (() => (__webpack_require__(49970))))));
			register("@tanstack/react-query", "4.2.1", () => (__webpack_require__.e(1537).then(() => (() => (__webpack_require__(71537))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(5803).then(() => (() => (__webpack_require__(95803))))));
			register("dayjs", "1.11.3", () => (__webpack_require__.e(4268).then(() => (() => (__webpack_require__(74268))))));
			register("fontfaceobserver", "2.3.0", () => (__webpack_require__.e(6502).then(() => (() => (__webpack_require__(16502))))));
			register("i18next-browser-languagedetector", "6.1.4", () => (__webpack_require__.e(6563).then(() => (() => (__webpack_require__(86563))))));
			register("i18next", "21.8.16", () => (Promise.all([__webpack_require__.e(8855), __webpack_require__.e(9973)]).then(() => (() => (__webpack_require__(58855))))));
			register("js-cookie", "3.0.1", () => (__webpack_require__.e(5594).then(() => (() => (__webpack_require__(85594))))));
			register("jsencrypt", "3.3.2", () => (__webpack_require__.e(6789).then(() => (() => (__webpack_require__(46789))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(4306).then(() => (() => (__webpack_require__(4306))))));
			register("libphonenumber-js", "1.10.14", () => (__webpack_require__.e(9660).then(() => (() => (__webpack_require__(99660))))));
			register("react-device-detect", "2.2.2", () => (__webpack_require__.e(6578).then(() => (() => (__webpack_require__(46578))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(15749))), 1);
			register("react-helmet-async", "1.3.0", () => (__webpack_require__.e(9586).then(() => (() => (__webpack_require__(19586))))));
			register("react-hook-form", "7.34.2", () => (__webpack_require__.e(3953).then(() => (() => (__webpack_require__(13953))))));
			register("react-i18next", "11.18.3", () => (__webpack_require__.e(3569).then(() => (() => (__webpack_require__(33569))))));
			register("react-otp-input", "2.4.0", () => (__webpack_require__.e(2185).then(() => (() => (__webpack_require__(72185))))));
			register("react-router-dom", "6.3.0", () => (Promise.all([__webpack_require__.e(1235), __webpack_require__.e(7896)]).then(() => (() => (__webpack_require__(61235))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(30969))), 1);
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(5415).then(() => (() => (__webpack_require__(15415))))));
			register("yup", "0.32.11", () => (__webpack_require__.e(6921).then(() => (() => (__webpack_require__(66921))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};